import React, {Component} from 'react';
import {subscribe} from "../actions/userActions";
import {actionWrapper} from '../helpers/';
import FooterViewComponent from '../components/Footer/FooterView';


class FooterLayout extends Component {
  constructor(props) {
    super(props);
    this.onSubscribe = this.onSubscribe.bind(this);
    this.clearError = this.clearError.bind(this);
    this.state = {
      errors: {
        error: []
      },
      success: false,
      inProgress: false,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !nextState.errors.length && !nextState.inProgress;
  }

  onSubscribe(data) {
    actionWrapper(this, data, subscribe).then(() => {
      this.setState({
        success: true
      })
    });
  }

  clearError() {
    this.setState({
      errors: {
        error: [],
      },
      success: false
    });
  }

  render() {
    return (
      <FooterViewComponent
        subscribe={this.onSubscribe}
        errors={this.state.errors.error}
        clearError={this.clearError}
        success={this.state.success}
      />
    );
  }
}

export default FooterLayout;



// WEBPACK FOOTER //
// ./src/containers/Footer.js